<section
  class="flex md:flex-row flex-col w-full justify-between items-center my-3 gap-3"
>
  <section
    class="relative flex w-full md:justify-start justify-between items-center gap-2"
  >
    <app-icon-button
      (click)="handleNavigate('prev', _mode()!, 1)"
      icon="ic:baseline-chevron-left"
    />
    <app-icon-button [cdkMenuTriggerFor]="c" size="sm">
      <p class="font-semibold text-base md:text-lg">
        {{ value() | date: 'y년 MM월' }}
      </p>
    </app-icon-button>
    <app-icon-button
      (click)="handleNavigate('next', _mode()!, 1)"
      icon="ic:baseline-chevron-right"
    />
  </section>
  <section
    class="flex flex-row gap-3 items-center min-w-max w-full md:w-auto justify-between md:justify-start"
  >
    <app-tabs
      [options]="modes"
      [value]="_mode() || 'month'"
      (valueChange)="handleModeChange($event)"
    />
    <ng-content />
  </section>
</section>

<ng-template #c>
  <div
    cdkMenu
    class="shadow-md fixed md:min-w-max md:inset-auto md:w-auto md:h-auto inset-0 items-center flex p-4 md:p-0 w-screen md:bg-transparent bg-black/70 h-screen z-[999] md:absolute md:top-[calc(100%+4px)]"
  >
    <app-input-calendar
      [attr.data-theme]="theme()"
      [date]="value()!"
      (select)="handleEvent($event)"
    />
  </div>
</ng-template>
